const data = require(`./data_${process.env.REACT_APP_BUILD_UID}/countries.json`)
const countries = [...data]

export default countries